// extracted by mini-css-extract-plugin
export default {"suggest-download":"BZueILEUJ92PYiiHMh_e","bannerWrap":"SV2T718iUhR9ZuXZqwjQ","home":"mfggbdrmjwcm2RZQzXZV","common_bganimation":"ZZb2NEYk70vAlooEGj02"};